import { frontendURL } from '../../../../helper/URLHelper';
import RealEstateFinancePage from '../pages/RealEstateFinancePage.vue';
import RealEstateFinanceTransactionDetailPage from '../pages/RealEstateFinanceTransactionDetailPage.vue';
import RealEstateFinanceInstallmentPage from '../pages/RealEstateFinanceInstallmentPage.vue';
import RealEstateFinanceStatusUpdatePage from '../pages/RealEstateFinanceStatusUpdatePage.vue';
import RealEstateFinanceBrokerTransferPage from '../pages/RealEstateFinanceBrokerTransferPage.vue';
import { financePermissions, financeManagePermissions } from './permissions';

export const financeRoutes = [
  {
    path: frontendURL('accounts/:accountId/operacao-imobiliaria/financeiro'),
    alias: [
      frontendURL('accounts/:accountId/operacao-imobiliaria/comissoes'),
      frontendURL('accounts/:accountId/financeiro-imobiliario'),
      frontendURL('accounts/:accountId/comissoes-imobiliarias'),
    ],
    name: 'operacao_imobiliaria_financeiro',
    component: RealEstateFinancePage,
    meta: { permissions: financePermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/financeiro/processos/:salesTransactionId/detalhes'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/operacao-imobiliaria/financeiro/:salesTransactionId/detalhes-processo'
      ),
      frontendURL(
        'accounts/:accountId/financeiro/:salesTransactionId/detalhes-processo'
      ),
    ],
    name: 'operacao_imobiliaria_financeiro_detalhes',
    component: RealEstateFinanceTransactionDetailPage,
    meta: { permissions: financePermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/financeiro/processos/:salesTransactionId/parcelas/:installmentId/status'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/operacao-imobiliaria/financeiro/:salesTransactionId/:installmentId/status'
      ),
      frontendURL(
        'accounts/:accountId/financeiro/:salesTransactionId/:installmentId/status'
      ),
    ],
    name: 'operacao_imobiliaria_financeiro_status',
    component: RealEstateFinanceInstallmentPage,
    meta: { permissions: financePermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/financeiro/processos/:salesTransactionId/parcelas/:installmentId/status/alterar'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/financeiro/:salesTransactionId/:installmentId/status/alterar'
      ),
    ],
    name: 'operacao_imobiliaria_financeiro_status_alterar',
    component: RealEstateFinanceStatusUpdatePage,
    meta: { permissions: financeManagePermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/financeiro/processos/:salesTransactionId/parcelas/:installmentId/status/transferir'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/operacao-imobiliaria/financeiro/:salesTransactionId/:installmentId/status/transferir'
      ),
      frontendURL(
        'accounts/:accountId/financeiro/:salesTransactionId/:installmentId/status/transferir'
      ),
    ],
    name: 'operacao_imobiliaria_financeiro_transferir_indice',
    redirect: to => ({
      name: 'operacao_imobiliaria_financeiro_status',
      params: {
        accountId: to.params.accountId,
        installmentId: to.params.installmentId,
        salesTransactionId: to.params.salesTransactionId,
      },
    }),
    meta: { permissions: financeManagePermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/financeiro/processos/:salesTransactionId/parcelas/:installmentId/status/transferir/:beneficiaryType'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/operacao-imobiliaria/financeiro/:salesTransactionId/:installmentId/status/transferir/:beneficiaryType'
      ),
      frontendURL(
        'accounts/:accountId/financeiro/:salesTransactionId/:installmentId/status/transferir/:beneficiaryType'
      ),
    ],
    name: 'operacao_imobiliaria_financeiro_transferir_tipo',
    redirect: to => ({
      name: 'operacao_imobiliaria_financeiro_status',
      params: {
        accountId: to.params.accountId,
        installmentId: to.params.installmentId,
        salesTransactionId: to.params.salesTransactionId,
      },
    }),
    meta: { permissions: financeManagePermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/financeiro/processos/:salesTransactionId/parcelas/:installmentId/status/transferir/:beneficiaryType/:beneficiaryId'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/operacao-imobiliaria/financeiro/:salesTransactionId/:installmentId/status/transferir/:beneficiaryType/:beneficiaryId'
      ),
      frontendURL(
        'accounts/:accountId/financeiro/:salesTransactionId/:installmentId/status/transferir/:beneficiaryType/:beneficiaryId'
      ),
    ],
    name: 'operacao_imobiliaria_financeiro_transferir',
    component: RealEstateFinanceBrokerTransferPage,
    meta: { permissions: financeManagePermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/financeiro/parcelas/:installmentId/transferir/:requestId'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/financeiro/:installmentId/status/transferir/usuario/:requestId'
      ),
    ],
    name: 'operacao_imobiliaria_financeiro_transferir_legacy',
    component: RealEstateFinanceBrokerTransferPage,
    meta: { permissions: financeManagePermissions },
  },
];
